import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { p as plural, c as cs, d as da, a as de, e as en, b as es, f as fr, h as hu, i as it, n as nl, j as pl, r as ru, s as sk, k as sl, t as tr, u as uk, g as getLocale, l as translate } from './utils2.js';
import { D as DEFAULT_LANG } from './const.js';
import { d as defineCustomElement$2 } from './mapy-review-badge-new2.js';

const locales = {
    bg: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, cs, { one: "оценка", few: "оценки", other: "оценки" })
    },
    cs: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, cs, { one: "hodnocení", few: "hodnocení", other: "hodnocení" })
    },
    da: {
        numberOfReviews: (d) => d.countText + plural(d.count, 0, da, { one: "anmeldelse", other: "anmeldelser" })
    },
    de: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, de, { one: "Bewertung", other: "Bewertungen" })
    },
    en: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, en, { one: "review", other: "reviews" })
    },
    es: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, es, { one: "hodnocení", other: "hodnocení" })
    },
    fi: {},
    fr: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, fr, { one: "évaluation", other: "évaluations" })
    },
    he: {},
    hr: {},
    hu: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, hu, { one: "hodnocení", other: "hodnocení" })
    },
    it: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, it, { one: "valutazione", other: "valutazioni" })
    },
    nl: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, nl, { one: "hodnocení", other: "hodnocení" })
    },
    no: {},
    pl: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, pl, { one: "ocena", few: "oceny", other: "ocen" })
    },
    pt: {},
    ro: {},
    ru: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, ru, { one: "отзыв", few: "отзыва", other: "отзывов" })
    },
    sk: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, sk, { one: "hodnotenie", few: "hodnotenia", other: "hodnotení" })
    },
    sl: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, sl, { one: "ocena", two: "oceni", few: "ocene", other: "ocen" })
    },
    sr: {},
    sv: {},
    tr: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, tr, { one: "hodnocení", other: "hodnocení" })
    },
    uk: {
        numberOfReviews: (d) => d.countText + " " + plural(d.count, 0, uk, { one: "відгук", few: "відгуки", other: "відгуків" })
    },
    vi: {}
};

const mapyReviewBadgeComposedNewCss = ":host{display:inline-flex;font-family:Arial, Helvetica, sans-serif;align-items:center;--font-size-small:12px;--font-size-medium:14px;--font-size-big:18px}:host([type=none]){display:none !important}:host([size=small]),:host([size=snippet]){gap:4px}:host([size=medium]){gap:6px}:host([size=big]){gap:6px}.texts{display:flex;flex-direction:column;text-align:left}.spoken-review{color:#000000}.number-of-reviews{color:#828282;font-size:var(--font-size-small);line-height:16px}:host([size=small]) .texts,:host([size=snippet]) .texts{gap:4px;flex-direction:row;align-items:center}:host([size=small]) .spoken-review,:host([size=snippet]) .texts{font-size:var(--font-size-small);line-height:20px}:host([size=medium]) .spoken-review{font-size:var(--font-size-medium);line-height:16px}:host([size=big]) .spoken-review{font-size:var(--font-size-big);line-height:24px}:host([size=snippet]) .number-of-reviews{color:#666666}";
const MapyReviewBadgeComposedNewStyle0 = mapyReviewBadgeComposedNewCss;

const MapyReviewBadgeComposedNew$1 = /*@__PURE__*/ proxyCustomElement(class MapyReviewBadgeComposedNew extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.size = "medium";
        this.type = "none";
        this.rating = 0;
        this.reviews = 0;
        this.text = "";
    }
    render() {
        const locale = getLocale(this.hostElement);
        let countText = this.reviews.toLocaleString(DEFAULT_LANG, { maximumFractionDigits: 0 });
        try {
            countText = this.reviews.toLocaleString(getLocale(this.hostElement), { maximumFractionDigits: 0 });
        }
        catch (ex) {
            //
        }
        if (this.type === "green" || this.type === "gray") {
            return h(Host, null, h("mapy-review-badge-new", { top: this.type === "green", rating: this.rating, size: this.size === "snippet" ? "small" : this.size, lang: locale }), h("div", { class: "texts" }, h("span", { class: "spoken-review" }, this.text), h("span", { class: "number-of-reviews" }, this.size === "snippet" ? `(${countText})` : translate(locales, locale, "numberOfReviews", { count: this.reviews, countText }))));
        }
        else if (this.type === "count") {
            return h(Host, null, h("span", { class: "number-of-reviews" }, translate(locales, locale, "numberOfReviews", { count: this.reviews, countText })));
        }
        return h(Host, null);
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewBadgeComposedNewStyle0; }
}, [1, "mapy-review-badge-composed-new", {
        "size": [513],
        "type": [513],
        "rating": [514],
        "reviews": [514],
        "text": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-badge-composed-new", "mapy-review-badge-new"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-badge-composed-new":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewBadgeComposedNew$1);
            }
            break;
        case "mapy-review-badge-new":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const MapyReviewBadgeComposedNew = MapyReviewBadgeComposedNew$1;
const defineCustomElement = defineCustomElement$1;

export { MapyReviewBadgeComposedNew, defineCustomElement };

//# sourceMappingURL=mapy-review-badge-composed-new.js.map